import moment from 'moment';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

import Data from '../../../../components/Display/Data';
import '../../../../components/Display/Data.scss';

import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';

import DocumentItem from '../../common/document/DocumentItem';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';

function NewsDetail({
  news,
  handleUpdateNews,
  handleDelete,
  handleCreateFile,
  handleUpdateFile,
  handleDeleteFile
}) {
  const updateNewsActions = [
    {
      onClick: handleUpdateNews,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (news) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette Actualité ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(news)
    });
  };

  const confirmDocumentDeletion = (document) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteFile(document)
    });
  };

  const newFileActions = [
    {
      onClick: handleCreateFile,
      label: 'Ajouter un fichier',
      icon: 'pi-plus'
    }
  ];

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateNewsActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={news.title} large />
          <Data
            key="publication_date"
            label={'Date de publication'}
            value={moment(news.publication_date).format('LL')}
            large
          />

          {/* <DataTag
            key="type"
            label={'Type'}
            tag={{
              label: getConstant('quatrebis.thematique', news.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
            large
          /> */}
          <MultipleDataTag key="tags" label={'Thématiques'} tags={news.tags} />
        </div>

        <div className="flex flex-wrap gap-5">
          <MultiLineData key="content" label={'Contenu'} value={news.content} large asHtml />
        </div>
      </Section>
      <Section label="Fichiers téléchargeables" actions={newFileActions}>
        {news.documents?.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {news.documents.map((file) => (
              <DocumentItem
                key={file.id}
                document={file}
                onUpdate={() => handleUpdateFile(file)}
                onDelete={() => confirmDocumentDeletion(file)}
              />
            ))}
          </div>
        ) : (
          <p className="italic text-slate-400 font-light">Non renseignés</p>
        )}
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'actualité"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(news)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default NewsDetail;
